export const UPDATE_FOOTER_PAGE_REQUEST = "UPDATE_FOOTER_PAGE_REQUEST";
export const UPDATE_FOOTER_PAGE_SUCCESS = "UPDATE_FOOTER_PAGE_SUCCESS";
export const UPDATE_FOOTER_PAGE_FAILED = "UPDATE_FOOTER_PAGE_FAILED";

export const FAQ_CREATE_REQUEST = "FAQ_CREATE_REQUEST";
export const FAQ_CREATE_SUCCESS = "FAQ_CREATE_SUCCESS";
export const FAQ_CREATE_FAILED = "FAQ_CREATE_FAILED";

export const FAQ_REMOVE_REQUEST = "FAQ_REMOVE_REQUEST";
export const FAQ_REMOVE_SUCCESS = "FAQ_REMOVE_SUCCESS";
export const FAQ_REMOVE_FAILED = "FAQ_REMOVE_FAILED";

export const GET_FOOTER_PAGE_REQUEST = "GET_FOOTER_PAGE_REQUEST";
export const GET_FOOTER_PAGE_SUCCESS = "GET_FOOTER_PAGE_SUCCESS";
export const GET_FOOTER_PAGE_FAILED = "GET_FOOTER_PAGE_FAILED";

export const GET_FOOTER_PAGE_MOBILESIDE_REQUEST =
  "GET_FOOTER_PAGE_MOBILESIDE_REQUEST";
export const GET_FOOTER_PAGE_MOBILESIDE_SUCCESS =
  "GET_FOOTER_PAGE_MOBILESIDE_SUCCESS";
export const GET_FOOTER_PAGE_MOBILESIDE_FAILED =
  "GET_FOOTER_PAGE_MOBILESIDE_FAILED";

export const updateFooterPageAction = (data) => {
  return { type: UPDATE_FOOTER_PAGE_REQUEST, payload: data };
};

export const createFAQPageAction = (data) => {
  return { type: FAQ_CREATE_REQUEST, payload: data };
};
export const RemoveFAQ = (data) => {
  return { type: FAQ_REMOVE_REQUEST, payload: data };
};

export const getFooterPageAction = (data) => {
  return { type: GET_FOOTER_PAGE_REQUEST, payload: data };
};

export const getFooterPageMobileSideAction = (data) => {
  return { type: GET_FOOTER_PAGE_MOBILESIDE_REQUEST, payload: data };
};
